
/* 生产环境样式保护 - 自动生成 */
// 此文件确保关键样式在生产环境中不被移除
import React from 'react';

const StyleGuard: React.FC = () => {
  return (
    <div style={{ display: 'none' }}>
      {/* 渐变样式保护 */}
      <div className="bg-gradient-to-r from-primary-500 to-primary-600" />
      <div className="bg-gradient-to-r from-primary-600 to-primary-700" />
      <div className="bg-gradient-to-r from-primary-50 to-primary-100" />
      <div className="bg-gradient-to-br from-primary-400 to-primary-600" />
      <div className="bg-gradient-to-r from-blue-50 to-blue-100" />
      <div className="bg-gradient-to-r from-success-500 to-success-600" />
      <div className="bg-gradient-to-r from-danger-500 to-danger-600" />
      <div className="bg-gradient-to-r from-green-50 to-emerald-50" />
      
      {/* Hover 状态保护 */}
      <div className="bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700" />
      
      {/* 背景色保护 */}
      <div className="bg-primary-50 bg-primary-500 bg-success-500 bg-danger-50 bg-danger-500" />
      <div className="hover:bg-danger-50" />
      
      {/* 边框和文本保护 */}
      <div className="border-primary-200 border-primary-600 border-t-primary-600" />
      <div className="text-primary-600 text-primary-700 text-danger-500 text-danger-600" />
      
      {/* 其他重要类保护 */}
      <div className="z-100 z-101 force-gradient-button" />
      <div className="animate-fade-in animate-slide-up animate-slide-down animate-spin" />
    </div>
  );
};

export default StyleGuard;
